import { c as _c } from "react/compiler-runtime";
import { Slot } from "@radix-ui/react-slot";
import type { ComponentPropsWithoutRef } from "react";
import { cn } from "@repo/blacksmith-ui/cn";
export const CHAT_CARD_CLASS = "rounded-lg bg-[var(--color-surface-inset)] px-3 py-3";
export const CHAT_CARD_INTERACTIVE_CLASS = "cursor-pointer transition-colors duration-0 hover:bg-[var(--color-surface-inset-hover)]";
type ChatCardProps = ComponentPropsWithoutRef<"div"> & {
  asChild?: boolean;
  interactive?: boolean;
};
export function ChatCard(t0) {
  const $ = _c(12);
  let asChild;
  let className;
  let interactive;
  let props;
  if ($[0] !== t0) {
    ({
      asChild,
      interactive,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = asChild;
    $[2] = className;
    $[3] = interactive;
    $[4] = props;
  } else {
    asChild = $[1];
    className = $[2];
    interactive = $[3];
    props = $[4];
  }
  const Comp = asChild ? Slot : "div";
  const t1 = interactive && CHAT_CARD_INTERACTIVE_CLASS;
  let t2;
  if ($[5] !== className || $[6] !== t1) {
    t2 = cn(CHAT_CARD_CLASS, t1, className);
    $[5] = className;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== Comp || $[9] !== props || $[10] !== t2) {
    t3 = <Comp className={t2} {...props} />;
    $[8] = Comp;
    $[9] = props;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}